module.exports = __webpack_public_path__ + "img/67_23.57240272.png";